import { render, staticRenderFns } from "./FEBS.vue?vue&type=template&id=9c4790a4"
import script from "./FEBS.vue?vue&type=script&lang=js"
export * from "./FEBS.vue?vue&type=script&lang=js"
import style0 from "./FEBS.vue?vue&type=style&index=0&id=9c4790a4&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports